<ng-container *ngIf="!isMobile; else mobileView">
  <ion-content (ionScroll)="onScroll($event)" scrollEvents="true">
    <ng-container *ngIf="{ cat: categories$ | async, events: events$ | async, auxEvents: auxEvents$ | async} as obs">
      <div class="sb-sticky">
        <sb-simple-navbar [hasBackButton]="true" [fakeButton]="true">
          <h4 class="sb-back--title color-light">{{ event?.Name }}</h4>
        </sb-simple-navbar>
        <sb-tabs-categories
          [categories]="obs?.cat"
          [color]="'regular'"
          [scrollable]="true"
          [smallButton]="true"
          [isMobile]="isMobile"
          [selectedTab]="currentCategory$ | async"
          (selectTab)="changeCategory($event)"
        ></sb-tabs-categories>
      </div>

      <div *ngIf="obs?.cat">
        <ion-list class="events-columns-desk m-unset has-no-padding" *ngIf="obs?.events as events">
          <sb-grid-item
            *ngFor="let event of events"
            [event]="event"
            [mode]="event?.mode"
            [special]="sportBookService?.isSpecialMarket(event?.LeagueName)"
            (navigate)="navigate(event)"
          >
            <ng-container
              *ngTemplateOutlet="
                      event?.mode === 'teams' ? teams : expanded;
                      context: { event: event }
                    "
              content
            >
            </ng-container>

            <sb-overview-score-sets
              *ngIf="event?.overviewScoreboard === SCOREBOARD_TYPE.SETS"
              [sportHandle]="event?.SportHandle"
              [scoreboard]="event?.liveData"
              scoreboard
            >
            </sb-overview-score-sets>

            <sb-overview-score-regular
              *ngIf="event?.overviewScoreboard === SCOREBOARD_TYPE.REGULAR"
              [scoreboard]="event?.liveData"
              scoreboard
            >
            </sb-overview-score-regular>

            <div
              class="sb-grid-item--bets-group"
              [ngClass]="'has-' + event?.Games?.length + '-groups'"
              [class.has-callback]="event?.Games?.length % 2 !== 0"
              *ngFor="let game of event?.Games; let index = index"
              bet-display
              [game]="game"
              [desktop]="isDesktop"
              [betType]="game?.DisplayTypeName"
              sb-markets
            >
              <sb-button
                *ngFor="
                        let result of game?.Results;
                        let index = index;
                        trackBy: utils?.trackBy
                      "
                [type]="game?.GameType"
                [typeName]="game?.DisplayTypeName"
                [game]="result"
                [results]="game?.Results"
                [index]="index"
                (bet)="bet($event, event, game?.Name, '1')"
                [selected]="newTicketFacade?.hasResult(result.NodeId)"
                [locked]="result?.Locked"
                [home]="event?.teamHome"
                [away]="event?.teamAway"
                [sport]="event?.SportHandle"
              >
              </sb-button>
            </div>
            <sb-counter
              *ngIf="!!event?.ChildrenCount && event?.mode !== 'expanded'"
              [count]="event?.ChildrenCount"
              (click)="navigate(event)"
              counter-button
            >
            </sb-counter>
          </sb-grid-item>
        </ion-list>
      </div>

      <ion-list class="events-columns-desk m-unset has-no-padding" *ngIf="obs?.auxEvents as events">

        <!-- TODO RESTRUCTURING ¿add w-100? -->
        <sb-header-with-counter [text]="'Apuestas Anticipadas'">
        </sb-header-with-counter>
        <sb-grid-item
          *ngFor="let event of events"
          [event]="event"
          [mode]="event?.mode"
          [special]="sportBookServ?.isSpecialMarket(event?.LeagueName)"
          (navigate)="navigate(event)"
        >
          <ng-container
            *ngTemplateOutlet="
                      event?.mode === 'teams' ? teams : expanded;
                      context: { event: event }
                    "
            content
          ></ng-container>
          <sb-overview-score-sets
            *ngIf="event?.overviewScoreboard === SCOREBOARD_TYPE.SETS"
            [sportHandle]="event?.SportHandle"
            [scoreboard]="event?.liveData"
            scoreboard
          ></sb-overview-score-sets>

          <sb-overview-score-regular
            *ngIf="event?.overviewScoreboard === SCOREBOARD_TYPE.REGULAR"
            [scoreboard]="event?.liveData"
            scoreboard
          ></sb-overview-score-regular>

          <div
            class="sb-grid-item--bets-group"
            [ngClass]="'has-' + event?.Games?.length + '-groups'"
            [class.has-callback]="event?.Games?.length % 2 !== 0"
            *ngFor="let game of event?.Games; let index = index"
            bet-display
            [game]="game"
            [desktop]="isDesktop"
            [betType]="game?.DisplayTypeName"
            sb-markets
          >
            <sb-button
              *ngFor="
                        let result of game?.Results;
                        let index = index;
                        trackBy: utils?.trackBy
                      "
              [type]="game?.GameType"
              [typeName]="game?.DisplayTypeName"
              [game]="result"
              [results]="game?.Results"
              [index]="index"
              (bet)="bet($event, event, event?.Name, '1')"
              [selected]="newTicketFacade?.hasResult(result.NodeId)"
              [locked]="result?.Locked"
              [home]="event?.teamHome"
              [away]="event?.teamAway"
              [sport]="event?.SportHandle"
            >
            </sb-button>
          </div>
          <sb-counter
            *ngIf="!!event?.ChildrenCount && event?.mode !== 'expanded'"
            [count]="event?.ChildrenCount"
            (click)="navigate(event)"
            counter-button
          >
          </sb-counter>
        </sb-grid-item>
      </ion-list>

      <codere-footer></codere-footer>
    </ng-container>
  </ion-content>

  <!--Overview Pages-->
  <ng-template #teams let-event="event" content>
    <sb-grid-content-teams [event]="event" content></sb-grid-content-teams>
  </ng-template>

  <ng-template #expanded let-event="event" content>
    <sb-grid-content-expanded [title]="event?.Name" [date]="event?.StartDate | sportsExtractDate" content>
    </sb-grid-content-expanded>
  </ng-template>
</ng-container>
<ng-template #mobileView>
  <ion-header>
    <codere-navbar></codere-navbar>

    <sb-simple-navbar [hasBackButton]="true" [fakeButton]="true">
      <h4 class="sb-back--title color-light">{{ event?.Name }}</h4>
    </sb-simple-navbar>
    <sb-tabs-categories
      [categories]="categories$ | async"
      [color]="'regular'"
      [scrollable]="true"
      [smallButton]="true"
      [isMobile]="isMobile"
      [selectedTab]="currentCategory$ | async"
      (selectTab)="changeCategory($event)"
    ></sb-tabs-categories>
  </ion-header>

  <ion-content (ionScroll)="onScroll($event)" scrollEvents="true">
    <ion-list class="m-unset" *ngIf="events$ | async as events">
      <!-- Directos --><!--TEMPLATE 3 - sixpax or not--->
      <ng-container *ngFor="let event of events; trackBy: utils?.trackBy">
        <sb-grid-item
          *ngIf="!event?.isSixPack"
          [event]="event"
          [mode]="event?.mode"
          [hasBets]="!!event?.Games?.length"
          [special]="sportBookService?.isSpecialMarket(event?.LeagueName)"
          (navigate)="navigate(event)"
        >
          <!--template outlet for content-->
          <ng-container *ngTemplateOutlet="event?.mode === 'teams' ? teams : expanded; context: {event: event}" content>
          </ng-container>
          <sb-overview-score-sets
            *ngIf="event?.overviewScoreboard === SCOREBOARD_TYPE.SETS"
            [sportHandle]="event?.SportHandle"
            [scoreboard]="event?.liveData"
            scoreboard
          >
          </sb-overview-score-sets>

          <sb-overview-score-regular
            *ngIf="event?.overviewScoreboard === SCOREBOARD_TYPE.REGULAR"
            [scoreboard]="event?.liveData"
            scoreboard
          >
          </sb-overview-score-regular>

          <div
            *ngFor="let game of event?.Games; let index = index"
            class="sb-grid-item--bets-group"
            [ngClass]="'has-' + event?.Games?.length + '-groups'"
            [game]="game"
            [betType]="game?.DisplayTypeName"
            bet-display
            sb-markets
          >
            <sb-button
              *ngFor="let result of game?.Results; let index = index; trackBy: utils?.trackBy"
              [type]="game?.GameType"
              [typeName]="game?.DisplayTypeName"
              [game]="result"
              [results]="game?.Results"
              [index]="index"
              [selected]="newTicketFacade?.hasResult(result?.NodeId)"
              [locked]="result?.Locked"
              [home]="event?.teamHome"
              [away]="event?.teamAway"
              (bet)="bet($event, event, game?.Name, '1')"
              [sport]="event?.SportHandle"
            >
            </sb-button>
          </div>
        </sb-grid-item>

        <!-- SIX PACK -->
        <ng-container *ngIf="event?.isSixPack">
          <sb-grid-header
            [titleLeft]="'Ganador'"
            [titleCenter]="'Handicap'"
            [titleRight]="'Totales'"
            [market]="event?.sixPack"
          >
          </sb-grid-header>

          <sb-grid-item
            [mode]="event?.sixPack?.displayMode"
            [event]="event?.sixPack"
            [betType]="event?.sixPack?.DisplayTypeName"
            [special]="sportBookService?.isSpecialMarket(event?.LeagueName)"
            (navigate)="navigate(event?.sixPack)"
          >
            <sb-grid-content-single
              [title]="event?.sixPack?.teamHome"
              [subtitle]="event?.sixPack?.pitcherHome"
              [countryCode]="event?.CountryCode"
              content
            >
            </sb-grid-content-single>
            <div class="sb-grid-item--bets-group" [betType]="event?.sixPack?.DisplayTypeName" bet-display sb-markets>
              <sb-button
                *ngFor="let result of (event?.sixPack?.combinedResults)[0]?.results; let indexCombinedBets = index; trackBy: utils?.trackBy"
                [typeName]="event?.sixPack?.DisplayTypeName"
                [type]="result?.GameType"
                [game]="result"
                [isCombined]="event?.sixPack?.isCombined"
                [results]="event?.sixPack?.GroupResults"
                [index]="indexCombinedBets"
                [selected]="newTicketFacade?.hasResult(result.NodeId)"
                [locked]="result?.Locked"
                [home]="event?.sixPack?.teamHome"
                [away]="event?.sixPack?.teamAway"
                [sport]="event?.SportHandle"
                (bet)="bet($event, event, event?.Name, '2')"
                bets
              >
              </sb-button>
            </div>
          </sb-grid-item>

          <sb-grid-item
            *ngIf="event?.isSixPack"
            class="sb-item-container-margin-bot"
            [mode]="event?.sixPack?.displayMode"
            [event]="event?.sixPack"
            [betType]="event?.sixPack?.DisplayTypeName"
            [special]="sportBookService?.isSpecialMarket(event?.LeagueName)"
            (navigate)="navigate(event?.sixPack)"
          >
            <sb-grid-content-single
              [title]="event?.sixPack?.teamAway"
              [subtitle]="event?.sixPack?.pitcherAway"
              [countryCode]="event?.CountryCode"
              content
            >
            </sb-grid-content-single>

            <div class="sb-grid-item--bets-group" bet-display [betType]="event?.sixPack?.DisplayTypeName" sb-markets>
              <sb-button
                *ngFor="let result of (event?.sixPack?.combinedResults)[1]?.results; let indexCombinedBets = index; trackBy: utils?.trackBy"
                [typeName]="event?.sixPack?.DisplayTypeName"
                [type]="result?.GameType"
                [game]="result"
                [isCombined]="event?.sixPack?.isCombined"
                [results]="event?.sixPack?.GroupResults"
                [locked]="result?.Locked"
                [index]="indexCombinedBets"
                [selected]="newTicketFacade?.hasResult(result?.NodeId)"
                [home]="event?.sixPack?.teamHome"
                [away]="event?.sixPack?.teamAway"
                [sport]="event?.SportHandle"
                (bet)="bet($event, event, event?.Name, '3')"
                bets
              >
              </sb-button>
            </div>
          </sb-grid-item>
        </ng-container>
      </ng-container>
    </ion-list>

    <ion-list class="m-unset" *ngIf="auxEvents$ | async as events">
      <!-- TODO RESTRUCTURING add w-100? -->
      <sb-header-with-counter *ngIf="events?.length" [text]="'Apuestas Anticipadas'">
      </sb-header-with-counter> 
      <ng-container *ngFor="let event of events; trackBy: utils?.trackBy">
        <sb-grid-item
          *ngIf="!event?.isSixPack"
          [event]="event"
          [mode]="event?.mode"
          [hasBets]="!!event?.Games?.length"
          [special]="sportBookService?.isSpecialMarket(event?.LeagueName)"
          (navigate)="navigate(event)"
        >
          <!--template outlet for content-->
          <ng-container *ngTemplateOutlet="event?.mode === 'teams' ? teams : expanded; context: {event: event}" content>
          </ng-container>

          <sb-overview-score-sets
            *ngIf="event?.overviewScoreboard === SCOREBOARD_TYPE.SETS"
            [sportHandle]="event?.SportHandle"
            [scoreboard]="event?.liveData"
            scoreboard
          ></sb-overview-score-sets>

          <sb-overview-score-regular
            *ngIf="event?.overviewScoreboard === SCOREBOARD_TYPE.REGULAR"
            [scoreboard]="event?.liveData"
            scoreboard
          ></sb-overview-score-regular>

          <div
            class="sb-grid-item--bets-group"
            *ngFor="let game of event?.Games; let index = index"
            [ngClass]="'has-' + event?.Games?.length + '-groups'"
            [game]="game"
            [betType]="game?.DisplayTypeName"
            bet-display
            sb-markets
          >
            <sb-button
              *ngFor="let result of game?.Results; let index = index; trackBy: utils?.trackBy"
              [type]="game?.GameType"
              [typeName]="game?.DisplayTypeName"
              [game]="result"
              [results]="game?.Results"
              [index]="index"
              [selected]="newTicketFacade.hasResult(result.NodeId)"
              [locked]="result?.Locked"
              [home]="event?.teamHome"
              [away]="event?.teamAway"
              (bet)="bet($event, event, game?.Name, '4')"
              [sport]="event?.SportHandle"
            >
            </sb-button>
          </div>
        </sb-grid-item>

        <!-- SIX PACK -->
        <ng-container *ngIf="event?.isSixPack">
          <sb-grid-header
            [titleLeft]="'Ganador'"
            [titleCenter]="'Handicap'"
            [titleRight]="'Totales'"
            [market]="event?.sixPack"
          >
          </sb-grid-header>

          <sb-grid-item
            [mode]="event?.sixPack?.displayMode"
            [event]="event?.sixPack"
            [betType]="event?.sixPack?.DisplayTypeName"
            [special]="sportBookService?.isSpecialMarket(event?.LeagueName)"
            (navigate)="navigate(event?.sixPack)"
          >
            <sb-grid-content-single
              [title]="event?.sixPack?.teamHome"
              [subtitle]="event?.sixPack?.pitcherHome"
              [countryCode]="event?.CountryCode"
              content
            >
            </sb-grid-content-single>

            <div class="sb-grid-item--bets-group" [betType]="event?.sixPack?.DisplayTypeName" bet-display sb-markets>
              <sb-button
                *ngFor="let result of (event?.sixPack?.combinedResults)[0]?.results; let indexCombinedBets = index; trackBy: utils?.trackBy"
                [typeName]="event?.sixPack?.DisplayTypeName"
                [type]="result?.GameType"
                [game]="result"
                [isCombined]="event?.sixPack?.isCombined"
                [results]="event?.sixPack?.GroupResults"
                [index]="indexCombinedBets"
                [selected]="newTicketFacade?.hasResult(result?.NodeId)"
                [locked]="result?.Locked"
                [home]="event?.sixPack?.teamHome"
                [away]="event?.sixPack?.teamAway"
                [sport]="event?.SportHandle"
                (bet)="bet($event, event, event?.Name, '5')"
                bets
              >
              </sb-button>
            </div>
          </sb-grid-item>

          <sb-grid-item
            class="sb-item-container-margin-bot"
            *ngIf="event?.isSixPack"
            [mode]="event?.sixPack?.displayMode"
            [event]="event?.sixPack"
            [betType]="event?.sixPack?.DisplayTypeName"
            [special]="sportBookService?.isSpecialMarket(event?.LeagueName)"
            (navigate)="navigate(event?.sixPack)"
          >
            <sb-grid-content-single
              [title]="event?.sixPack?.teamAway"
              [subtitle]="event?.sixPack?.pitcherAway"
              [countryCode]="event?.CountryCode"
              content
            >
            </sb-grid-content-single>

            <div class="sb-grid-item--bets-group" [betType]="event?.sixPack?.DisplayTypeName" bet-display sb-markets>
              <sb-button
                *ngFor="let result of (event?.sixPack?.combinedResults)[1]?.results; let indexCombinedBets = index; trackBy: utils?.trackBy"
                [typeName]="event?.sixPack?.DisplayTypeName"
                [type]="result?.GameType"
                [game]="result"
                [isCombined]="event?.sixPack?.isCombined"
                [results]="event?.sixPack?.GroupResults"
                [locked]="result?.Locked"
                [index]="indexCombinedBets"
                [selected]="newTicketFacade?.hasResult(result?.NodeId)"
                [home]="event?.sixPack?.teamHome"
                [away]="event?.sixPack?.teamAway"
                [sport]="event?.SportHandle"
                (bet)="bet($event, event, event?.Name, '6')"
                bets
              >
              </sb-button>
            </div>
          </sb-grid-item>
        </ng-container>
      </ng-container>
    </ion-list>

    <codere-footer></codere-footer>
  </ion-content>

  <!--Overview Pages-->
  <ng-template #teams let-event="event" content>
    <sb-grid-content-teams [event]="event" content> </sb-grid-content-teams>
  </ng-template>

  <ng-template #expanded let-event="event" content>
    <sb-grid-content-expanded [title]="event?.Name" [date]="event?.StartDate | sportsExtractDate" content>
    </sb-grid-content-expanded>
  </ng-template>
</ng-template>
